import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { SecurityBenchmark } from '../store/types';

interface Props {
  items: SecurityBenchmark[] | null;
  selectedItem: SecurityBenchmark | null;
  setBenchmark: (benchmark: SecurityBenchmark | null) => void;
}

export const BenchmarkSelect = (props: Props): JSX.Element => {
  const { selectedItem, items, setBenchmark } = props;
  const benchmarks = items || [];

  return (
    <Autocomplete
      style={{ width: '420px' }}
      id="benchmark-select"
      value={selectedItem}
      options={benchmarks}
      getOptionLabel={(option) => {
        return option.name ? option.name : '';
      }}
      renderInput={(params) => <TextField {...params} label="Benchmark" variant="outlined" fullWidth />}
      onChange={(_event: React.SyntheticEvent<Element, Event>, value: SecurityBenchmark | null) => setBenchmark(value)}
    />
  );
};
